export default __webpack_public_path__ + "static/media/delete_circle_icon.890d8804.svg";